import { useQuery } from '@tanstack/react-query';
import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getUserReferralInfoApi } from '@flipster/apis/v1/user';
import { useCookie } from '@flipster/react/misc/browser/cookie';
import { CookieKeys } from '@flipster/utils/cookie';

import { authBunja, useAuth } from '../auth/state';

export const referralCodeBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);

  const referralCodeQueryAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);
    return {
      queryKey: ['getUserReferralInfoApi', isCookieLoggedIn],
      queryFn: getUserReferralInfoApi,
      enabled: isCookieLoggedIn,
    };
  });

  const referralCodeAtom = atom((get) => {
    const { data } = get(referralCodeQueryAtom);
    return data?.data.code;
  });

  const signUpCodeAtom = atom((get) => {
    const { data } = get(referralCodeQueryAtom);
    return data?.data.signUpCode || null;
  });

  return {
    referralCodeQueryAtom,
    referralCodeAtom,
    signUpCodeAtom,
  };
});
referralCodeBunja.debugLabel = 'referralCodeBunja';

export const useReferralCode = (options?: { enabled?: boolean }) => {
  const { isLoggedIn } = useAuth();
  const { data: referralCode, isPending } = useQuery({
    queryKey: ['getUserReferralInfoApi', 'code', isLoggedIn],
    queryFn: getUserReferralInfoApi,
    select: (res) => res.data.code,
    enabled: isLoggedIn,
    ...options,
  });

  return { referralCode, isLoading: isPending };
};

export const useReferralInfo = () => {
  const [referral_code = null] = useCookie(CookieKeys.ReferralCode);
  const [referral_type = null] = useCookie(CookieKeys.ReferralType);

  return { referral_code, referral_type };
};
